import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';
import { C3Service } from '../../c3.service';
import { ToolbarComponent } from '../toolbar/toolbar.component';

// declare function require(name: string);

@Component({
    selector: 'app-main-toolbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: '../toolbar/toolbar.component.html',
    styleUrls: ['../toolbar/toolbar.component.scss'],
    standalone: false
})
export class MainToolbarComponent extends ToolbarComponent {
  @Output() public cuttingPlaneToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() public isosurfaceToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() public isovolumeToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() public particleTraceToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() public resultsToggle: EventEmitter<void> = new EventEmitter<void>();
  @Output() public animationToggle: EventEmitter<void> = new EventEmitter<void>();

  public constructor(elementRef: ElementRef, c3Service: C3Service) {
    super(elementRef);

    this.items = [
      {
        imageUrl: 'assets/pan.svg',
        tooltip: 'Pan',
        execute: () => (c3Service._view['0'].navigation.config.leftMouseButton.noModifier = cee.NavigationType.PAN),
        getActive: () => c3Service._view['0'].navigation.config.leftMouseButton.noModifier === cee.NavigationType.PAN,
      },
      {
        imageUrl: 'assets/rotate.svg',
        tooltip: 'Rotate',
        execute: () => (c3Service._view['0'].navigation.config.leftMouseButton.noModifier = cee.NavigationType.ROTATE),
        getActive: () =>
          c3Service._view['0'].navigation.config.leftMouseButton.noModifier === cee.NavigationType.ROTATE,
      },
      // {
      //     imageUrl: require("../../assets/images/zoom.svg"),
      //     tooltip: "Zoom",
      //     execute: () => c3Service.view.navigation.config.leftMouseButton.noModifier = cee.NavigationType.ZOOM,
      //     getActive: () => c3Service.view.navigation.config.leftMouseButton.noModifier === cee.NavigationType.ZOOM,
      // },
      {
        divider: true,
      },
      // {
      //     imageUrl: require("../../assets/images/draw-style/surface.png"),
      //     tooltip: "Set draw style all parts to Surface",
      //     execute: () => c3Service.model.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE),
      // },
      // {
      //     imageUrl: require("../../assets/images/draw-style/lines.png"),
      //     tooltip: "Set draw style all parts to Lines",
      //     execute: () => c3Service.model.setDrawStyleAllParts(cee.ug.DrawStyle.LINES),
      // },
      // {
      //     imageUrl: require("../../assets/images/draw-style/outlines.png"),
      //     tooltip: "Set draw style all parts to Outline",
      //     execute: () => c3Service.model.setDrawStyleAllParts(cee.ug.DrawStyle.OUTLINE),
      // },
      // {
      //     imageUrl: require("../../assets/images/draw-style/mesh.svg"),
      //     tooltip: "Set draw style all parts to Surface Mesh",
      //     execute: () => c3Service.model.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE_MESH),
      // },
      // {
      //     imageUrl: require("../../assets/images/draw-style/meshoutlines.png"),
      //     tooltip: "Set draw style all parts to Outline Mesh",
      //     execute: () => c3Service.model.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE_OUTLINE_MESH),
      // },
      // {
      //     divider: true,
      // },
      {
        imageUrl: 'assets/fringes.png',
        tooltip: 'Results',
        execute: () => this.resultsToggle.next(),
      },
      {
        imageUrl: 'assets/cuttingplane2.png',
        tooltip: 'Cutting planes',
        execute: () => this.cuttingPlaneToggle.next(),
      },
      {
        imageUrl: 'assets/isosurface.png',
        tooltip: 'Isosurfaces',
        execute: () => this.isosurfaceToggle.next(),
      },
      {
        imageUrl: 'assets/isovolume.png',
        tooltip: 'Isovolumes',
        execute: () => this.isovolumeToggle.next(),
      },
      {
        imageUrl: 'assets/particletrace.png',
        tooltip: 'Particle traces',
        execute: () => this.particleTraceToggle.next(),
      },
      {
        divider: true,
      },
      // {
      //     imageUrl: "assets/cycle_animation.png",
      //     tooltip: "Animations",
      //     execute: () => this.animationToggle.next(),
      // },
    ];
  }
}
